import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import connect from "react-redux/es/connect/connect";

class ModalApps extends React.Component {

    render() {
        return (
            <div>
                <Modal size={'xs'} isOpen={this.props.openModal} toggle={this.props.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Descarcă aplicațiile...</ModalHeader>
                    <ModalBody>
                        <div className="col-lg-12 apps-section">
                            <div className="row">
                                <div className="col-6 hr-padding-5">
                                    <a href={ process.env.REACT_APP_PLAY_STORE_URL } target="_blank">
                                        <span className="apps google-play-jpg"/>
                                    </a>

                                </div>
                                <div className="col-6 hr-padding-5">
                                    <a href={ process.env.REACT_APP_APPLE_STORE_URL } target="_blank">
                                        <span className="apps apple-store-jpg"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.props.toggle}>Inchide</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({

});
export default connect(mapStateToProps, {})(ModalApps);


// WEBPACK FOOTER //
// ./src/SHARED/components/modalapps/modalapps.component.js